import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@ublend-npm/react-tooltip';
import Popper from '@material-ui/core/Popper';
import MenuList from '@material-ui/core/MenuList';
import Grow from '@material-ui/core/Grow';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import MoreHoriz from '@material-ui/icons/MoreHoriz';
import Button from '$components/Button';
import Modal from '$components/Modal';
import {
  MenuContent,
  MenuItem,
  MenuDivider,
  ModalContent,
} from './ContextMenu.styles';

const ContextMenu = ({ menuItems }) => {
  const buttonRef = useRef(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [confirmingItem, setConfirmingItem] = useState(null);
  const clearConfirmation = () => setConfirmingItem(null);

  const handleSubmitConfirmation = (e) => {
    e.preventDefault();
    confirmingItem.onClick();
    clearConfirmation(null);
  };

  const createClickHandler = (item) => (e) => {
    e.preventDefault();
    setIsMenuOpen(false);

    if (item.confirmation) {
      setConfirmingItem(item);
    } else {
      item.onClick();
    }
  };

  return (
    <>
      <Tooltip title="More options" position="left" enabled>
        <Button
          ref={buttonRef}
          onClick={() => setIsMenuOpen(true)}
          size="iconMedium"
          look="secondary"
          label="More options"
        >
          <MoreHoriz />
        </Button>
      </Tooltip>
      <Popper
        open={isMenuOpen}
        anchorEl={buttonRef.current}
        transition
        disablePortal
        placement="bottom-end"
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps} style={{ transformOrigin: 'right top' }}>
            <MenuContent>
              <ClickAwayListener onClickAway={() => setIsMenuOpen(false)}>
                <MenuList>
                  {menuItems.map(({ divider, title, Icon, ...item }) => [
                    <MenuItem key={title} onClick={createClickHandler(item)}>
                      <Icon fontSize="small" />
                      {title}
                    </MenuItem>,
                    divider && <MenuDivider component="li" />,
                  ])}
                </MenuList>
              </ClickAwayListener>
            </MenuContent>
          </Grow>
        )}
      </Popper>
      {confirmingItem && (
        <Modal
          open
          handleClose={clearConfirmation}
          handleSubmit={handleSubmitConfirmation}
          headerText={confirmingItem.confirmation.title}
          submitText={confirmingItem.confirmation.submitText}
          footerDecoration={
            <Button
              onClick={clearConfirmation}
              label="Cancel"
              size="large"
              look="secondary"
            >
              Cancel
            </Button>
          }
        >
          <ModalContent>{confirmingItem.confirmation.message}</ModalContent>
        </Modal>
      )}
    </>
  );
};

ContextMenu.propTypes = {
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      Icon: PropTypes.elementType.isRequired,
      divider: PropTypes.bool,
    })
  ),
};

ContextMenu.defaultProps = {
  menuItems: [],
};

export default ContextMenu;
